import React from "react";
import "./About.css";
import aboutImg1 from "../assets/gallery/IMG_3994.jpg"; // main image
import aboutImg2 from "../assets/gallery/IMG_3996.jpg"; // small overlay image

const About = () => {
  
  return (
    <section className="about-section" id="about">
      <div className="about-container">
        {/* Left Side Images */}
        <div className="about-image">
          <img src={aboutImg1} alt="About main" className="main-img" />
          <img src={aboutImg2} alt="About small" className="overlay-img" />
        </div>

        {/* Right Side Content */}
        <div className="about-content">
          <h2>About Us</h2>
          <p>
            We are a trusted provider of <strong>paints, hardware, and electrical solutions</strong> 
            dedicated to delivering quality products and reliable service for every home and business. 
            Our goal is to help customers create beautiful, durable, and functional spaces with ease and confidence.
          </p>
          <p>
            With a commitment to excellence and customer satisfaction, we offer a comprehensive 
            selection of premium paints, building materials, and electrical supplies from leading brands. 
            Whether you’re a homeowner, contractor, or professional painter, we provide the right products 
            and expert guidance to bring your ideas to life.
          </p>
          
        </div>
      </div>
    </section>
  );
};

export default About;
